import { render, staticRenderFns } from "./addSupervisionMatch.vue?vue&type=template&id=37d56848&scoped=true&"
import script from "./addSupervisionMatch.vue?vue&type=script&lang=js&"
export * from "./addSupervisionMatch.vue?vue&type=script&lang=js&"
import style0 from "./addSupervisionMatch.vue?vue&type=style&index=0&id=37d56848&lang=stylus&scoped=true&"
import style1 from "./addSupervisionMatch.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./addSupervisionMatch.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d56848",
  null
  
)

export default component.exports